import {
	InputOTP,
	InputOTPGroup,
	InputOTPSlot,
} from '@/components/ui/input-otp';
import { REGEXP_ONLY_DIGITS_AND_CHARS } from 'input-otp';

interface Props {
	regex?: string;
	value?: string | undefined;
	length: number;
	classNameSlot?: string;
	onChange?: (value: string) => void;
}

const CustomInputOtp: React.FC<Props> = ({
	regex = REGEXP_ONLY_DIGITS_AND_CHARS,
	value,
	onChange,
	length,
	classNameSlot,
	...rest
}) => {
	return (
		<InputOTP
			maxLength={length}
			pattern={regex}
			value={value}
			onChange={onChange}
			className="w-full flex"
			{...rest}
		>
			<InputOTPGroup className="flex gap-2 w-full">
				{Array.from({ length }, (_, index) => (
					<InputOTPSlot
						key={index}
						className={`h-11 w-10 rounded-md border ring-0 bg-gray-25 ${classNameSlot}`}
						index={index}
					/>
				))}
			</InputOTPGroup>
		</InputOTP>
	);
};

export default CustomInputOtp;
